import TableContainer from "@mui/material/TableContainer";
import {
  Button,
  CircularProgress,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { LinkButton } from "../../components/LinkButton";
import { useGetDisplayDate } from "../../components/ZonedDateTimePicker";
import { ImageSize } from "../bands";
import { useIsSuperAdmin } from "../../App";
import { CompressArtistImage } from "../band/edit/compressArtistImage";
import { EditionBand } from ".";
import HasImageIcon from "../../components/HasImageIcon";
interface IBandTableProps {
  bands: EditionBand[];
  eventTimezone: string;
  getImageSize: boolean;
  title: string;
  onRemoveBooking?: (bookingId: string, bandName: string) => void;
  removingBookingId?: string | null;
}

const BandsTable = ({
  bands,
  eventTimezone,
  getImageSize,
  title,
  onRemoveBooking,
  removingBookingId,
}: IBandTableProps) => {
  const { getFormattedDate } = useGetDisplayDate();
  const isSuperAdmin = useIsSuperAdmin();

  return (
    <>
      <h2>{title}</h2>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left" width="20%">
                name
              </TableCell>
              <TableCell align="left" width="10%">
                times ({eventTimezone})
              </TableCell>
              <TableCell align="left" width="10%">
                duration
              </TableCell>
              <TableCell align="left" width="10%">
                stage
              </TableCell>
              <TableCell align="left" width="10%">
                announcement
              </TableCell>
              <TableCell align="left" width="10%">
                has image
              </TableCell>
              <TableCell align="left" width="10%">
                has desc
              </TableCell>
              {getImageSize && <TableCell align="left">has image</TableCell>}
              <TableCell align="left" width="25%">
                actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bands
              // @ts-ignore
              .sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
              .map((row) => {
                const isRemovingThisRow = removingBookingId === row.id;
                return (
                  <TableRow key={row.id}>
                    <TableCell align="left">{row.band.name}</TableCell>
                    <TableCell align="left">
                      {getFormattedDate(row.startTime, eventTimezone)} -{" "}
                      {getFormattedDate(row.endTime, eventTimezone)}
                    </TableCell>
                    <TableCell align="left">{row.duration ?? "-"}</TableCell>
                    <TableCell align="left">{row.stage?.name ?? "-"}</TableCell>
                    <TableCell align="left">{row.source}</TableCell>
                    <TableCell align="left">
                      <HasImageIcon
                        hasImage={
                          !!(
                            row.band.imageUrl &&
                            row.band.imageUrl.trim().length > 0
                          )
                        }
                      />
                    </TableCell>
                    <TableCell align="left">
                      <HasImageIcon
                        hasImage={
                          !!(
                            row.band.description &&
                            row.band.description.trim().length > 0
                          )
                        }
                      />
                    </TableCell>
                    {getImageSize && (
                      <TableCell align="left">
                        <ImageSize imageUrl={row.band.imageUrl} />
                      </TableCell>
                    )}
                    <TableCell align="left">
                      <LinkButton path={`/booking/${row.id}`} text="View" />
                      <LinkButton
                        path={`/band/${row.band.id}`}
                        text="View Band"
                      />
                      {row.source !== "Edition" && onRemoveBooking && (
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          onClick={() => onRemoveBooking(row.id, row.band.name)}
                          disabled={isRemovingThisRow}
                          sx={{ ml: 1 }}
                          startIcon={
                            isRemovingThisRow ? (
                              <CircularProgress color="inherit" size={14} />
                            ) : undefined
                          }
                        >
                          {isRemovingThisRow ? "Removing..." : "Remove booking"}
                        </Button>
                      )}
                      {isSuperAdmin && getImageSize && (
                        <CompressArtistImage band={row.band} />
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default BandsTable;
